import React from 'react'

const PaymentInfo = () =>{
  return (
    <div>PaymentInfo</div>
  )
}

export default PaymentInfo